<form id="contract-vendor-modal-form" class="form-validate" #form="ngForm" (submit)="search()">
  <div class="modal-header">
    <h6 class="modal-title text-muted">เลือกเครือข่ายหน่วยบริการ</h6>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body overflow-hidden">
    <div class="row mb-3">
      <label for="selectedProvince" class="col-xl-2 col-form-label ui-require">จังหวัด</label>
      <div class="col-xl-4">
        <app-select-mastercup-province id="selectedProvince"
                                       name="selectedProvince"
                                       [(ngModel)]="selectedProvince"
                                       (ngModelChange)="onProvinceChange()"
                                       [defaultFirstVal]="false"
                                       required
                                       [options]="options()"
                                       #province="ngModel"></app-select-mastercup-province>
        @if (province.invalid && (province.dirty || province.touched)) {
          <custom-error *ngIf="province.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>
    <div class="row mb-3">
      <label for="selectedDistrict" class="col-xl-2 col-form-label ui-require">อำเภอ/เขต</label>
      <div class="col-xl-4">
        <app-select-mastercup-district id="selectedDistrict"
                                       name="selectedDistrict"
                                       [(ngModel)]="selectedDistrict"
                                       (ngModelChange)="onDistrictChange()"
                                       [provinceId]="selectedProvince()?.id"
                                       required
                                       [options]="options()"
                                       #district="ngModel"></app-select-mastercup-district>
        @if (district.invalid && (district.dirty || district.touched)) {
          <custom-error *ngIf="district.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>
    @if (selectedProvince()?.id != '1000') {
      <div class="row mb-3">
        <label for="selectedSubDistrict" class="col-xl-2 col-form-label ui-require">ตำบล/แขวง</label>
        <div class="col-xl-4">
          <app-select-mastercup-subdistrict id="selectedSubDistrict"
                                            name="selectedSubDistrict"
                                            [(ngModel)]="selectedSubDistrict"
                                            [districtId]="selectedDistrict()?.code"
                                            (ngModelChange)="onSubDistrictChange()"
                                            required
                                            [options]="options()"
                                            #subDistrict="ngModel"></app-select-mastercup-subdistrict>
          @if (subDistrict.invalid && (subDistrict.dirty || subDistrict.touched)) {
            <custom-error *ngIf="subDistrict.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
      </div>
      <div class="row mb-3">
        <label for="selectedMoo" class="col-xl-2 col-form-label">หมู่</label>
        <div class="col-xl-4">
          <app-select-moo id="selectedMoo"
                          name="selectedMoo"
                          [(ngModel)]="selectedMoo"
                          [subDistrictId]="selectedSubDistrict()?.code"></app-select-moo>
        </div>
      </div>
    }


    <div class="row mb-3">
      <div class="col-xl-12 text-center align-content-center justify-content-center">
        <button type="submit" class="btn btn-primary me-3">
          <i class="bi bi-search me-1"></i>ค้นหา
        </button>
        <button type="submit" class="btn btn-outline-secondary me-3" (click)="clear()">
          <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-borderless table-hover caption-top">
        <caption></caption>
        <thead>
        <tr>
          <th nowrap scope="col">ลำดับ</th>
          <th nowrap scope="col">สถานะ</th>
          <th nowrap scope="col">รหัสเครือข่าย</th>
          <th nowrap scope="col">หน่วยบริการปฐมภูมิ</th>
          <th nowrap scope="col">หน่วยบริการประจำ</th>
          <th nowrap scope="col">หน่วยบริการที่รับการส่งต่อ</th>
          <th nowrap scope="col">{{ labelHmainHost }}</th>
          <th nowrap scope="col">Model</th>
          <th nowrap scope="col"></th>
          <th nowrap scope="col"></th>
        </tr>
        </thead>
        <tbody>
          @for (mastercup of pageData?.content; let i = $index; track mastercup.id) {
            <tr>
              <td nowrap class="text-center">{{ (pageData.size * pageData.number) + (i + 1) }}</td>
              <td>
                <app-mastercup-status [mastercup]="mastercup"></app-mastercup-status>
              </td>
              <td>{{ mastercup.mastercupId || '-' }}</td>
              <td>{{ mastercup.hospSub?.displayName || '-' }}</td>
              <td>{{ mastercup.hospMainOp?.displayName || '-' }}</td>
              <td>{{ mastercup.hospMain?.displayName || '-' }}</td>
              <td>{{ mastercup.hospMainHostDisplayName || mastercup.hmainHost || '-' }}</td>
              <td>{{ mastercup.paidModel || '-' }}</td>
              <td>
                @if (mastercup.selectable) {
                  <button type="button" class="btn btn-default" (click)="select(mastercup)">
                    <i class="bi bi-box-arrow-down"></i>
                  </button>
                }
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="9">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row justify-content-between">
      <div class="col-xl-6 text-muted">
        (รายการที่พบทั้งหมด {{ pageData?.content?.length || 0 }} รายการ , หน้า : {{ pageData?.number + 1 }}
        / {{ pageData.totalPages || 0 }})
      </div>
      <div class="col-xl-6">
        <ngb-pagination class="d-flex justify-content-end"
                        ngbAutofocus
                        [page]="pageData?.number + 1"
                        [pageSize]="pageData?.size"
                        (pageChange)="search($event)"
                        [boundaryLinks]="true"
                        [collectionSize]="pageData?.totalElements"/>
      </div>
    </div>
  </div>
</form>
